module.exports = __webpack_public_path__ + "img/icon-supply4.4ae978dc.png";